module.exports = __webpack_public_path__ + "static/Vinay 2-054b75d182920d9d3d3166d7e42e6a49.jpg";